import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Scrollbar} from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import 'swiper/css/scrollbar';

interface SliderProps {
  images: string[];
}

const Slider: React.FC<SliderProps> = ({ images }) => (
  <Swiper slidesPerView={1} modules={[Navigation, Scrollbar]} navigation 
  scrollbar={{ draggable: true }} className="full-height-swiper">
    {images.map((image, index) => (
      <SwiperSlide key={index} className="full-height-slide">
        <img src={image} alt={`Slide ${index + 1}`} className="full-image" />
      </SwiperSlide>
    ))}
  </Swiper>
);

export default Slider;
